<template>
  <!-- start preloader -->
  <!-- <div class="preloader" id="preloader"></div> -->
  <!-- end preloader -->

  <!-- Scroll To Top Start-->
  <!-- <router-link to="javascript:void(0)" class="scrollToTop"
    ><i class="fas fa-angle-double-up"
  /></router-link> -->
  <!-- Scroll To Top End -->

  <!-- banner section begin -->
  <div class="banner" id="home">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-8 col-sm-8">
          <div class="banner-txt">
            <h4>Play Casino</h4>
            <h1>Play Online Casino & Win Money Unlimited</h1>
            <router-link to="/casino/all" class="def-btn">play now</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- banner section end -->

  <!-- about section begin -->
  <div class="about" id="about">
    <div class="container">
      <div class="feature">
        <div class="row">
          <div class="col-xl-3 col-lg-3">
            <div class="single-feature">
              <div class="part-icon">
                <img src="../assets/images/games/assets-1.png" alt="" />
              </div>
              <h4 class="feature-title">Online Casino</h4>
              <router-link to="/casino/all" class="def-btn def-small">
                Play Now
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="long-arrow-right"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-long-arrow-right fa-w-14 fa-fw fa-2x">
                  <path
                    fill="currentColor"
                    d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
                    class=""></path>
                </svg>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3">
            <div class="single-feature">
              <div class="part-icon">
                <img src="../assets/images/games/assets-3.png" alt="" />
              </div>
              <h4 class="feature-title">Club Poker</h4>
              <router-link to="/casino/all" class="def-btn def-small">
                Play Now
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="long-arrow-right"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-long-arrow-right fa-w-14 fa-fw fa-2x">
                  <path
                    fill="currentColor"
                    d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
                    class=""></path>
                </svg>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3">
            <div class="single-feature">
              <div class="part-icon">
                <img src="../assets/images/games/assets-6.png" alt="" />
              </div>
              <h4 class="feature-title">Royal casino</h4>
              <router-link to="/casino/all" class="def-btn def-small">
                Play Now
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="long-arrow-right"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-long-arrow-right fa-w-14 fa-fw fa-2x">
                  <path
                    fill="currentColor"
                    d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
                    class=""></path>
                </svg>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3">
            <div class="single-feature">
              <div class="part-icon">
                <img src="../assets/images/games/assets-7.png" alt="" />
              </div>
              <h4 class="feature-title">Slots 375</h4>
              <router-link to="/casino/all" class="def-btn def-small">
                Play Now
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="long-arrow-right"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-long-arrow-right fa-w-14 fa-fw fa-2x">
                  <path
                    fill="currentColor"
                    d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
                    class=""></path>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div
        class="row justify-content-xl-between justify-content-lg-between justify-content-sm-center">
        <div class="col-xl-4 col-lg-4 col-sm-10 col-md-6">
          <div class="part-txt">
            <h2>Games are fun with Betrider</h2>
            <p>
              Experience the thrill of gaming like never before. Whether you
              love action-packed adventures, strategic challenges, or casual
              fun.
              <span
                >"Experience the thrill of online gambling with our secure
                platform. Experience the thrill of online gambling with our
                secure platform."</span
              >
            </p>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-4 d-xl-block d-lg-block d-md-none tw-relative">
          <div class="part-img">
            <div class="single-img">
              <img src="../assets/images/about-img.jpg" alt="img" />
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-sm-10 col-md-6">
          <div class="part-txt right">
            <h3>So, You should choose it</h3>
            <p>
              Why settle for ordinary gaming when you can have an extraordinary
              experience? Betrider offers unbeatable excitement, exclusive
              rewards, and a seamless gaming platform designed for players like
              you. Whether you're a casual gamer or a competitive pro, our
              diverse collection of games ensures non-stop fun. Join the
              Betrider community today and level up your gaming journey!
            </p>
            <!-- <a href="#0" class="def-btn">learn more</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- about section end -->

  <!-- iq feature begin -->
  <!-- <div class="iq-feature" id="feature">
    <div class="container">
      <div
        class="row justify-content-xl-end justify-content-lg-end justify-content-sm-center">
        <div
          class="col-xl-5 col-lg-6 col-sm-10 col-md-7 d-xl-flex d-lg-flex d-block align-items-center">
          <div class="part-text">
            <h2>Use IQN easily in Misco</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
              iusto, fuga consequuntur laudantium porro suscipit minima,
              delectus commodi possimus animi nesciunt neque hic fugiat. Alias
              sequi consectetur voluptate voluptatum quaerat.
            </p>
            <p>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aperiam
              reprehenderit molestiae in, illo similique.
            </p>
            <a href="#0" class="def-btn">play now</a>
          </div>
        </div>
        <div
          class="col-xl-4 col-lg-5 col-sm-10 col-md-5 offset-xl-1 offset-lg-1 offset-0">
          <div class="part-img">
            <img src="../assets/images/iq-img.jpg" alt="" />
            <div class="part-video">
              <a
                href="#"
                data-video-id="5hhlW_SYJBA"
                class="js-video-button play-button">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fal"
                  data-icon="play"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-play fa-w-14 fa-fw fa-2x">
                  <path
                    fill="currentColor"
                    d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zm-16.2 55.1l-352 208C45.6 483.9 32 476.6 32 464V47.9c0-16.3 16.4-18.4 24.1-13.8l352 208.1c10.5 6.2 10.5 21.4.1 27.6z"
                    class=""></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="part-features">
        <div class="row justify-content-sm-center justify-content-md-start">
          <div class="col-xl-4 col-lg-4 col-sm-10 col-md-6">
            <div class="single-feature">
              <img
                class="icon"
                src="assets/img/svg/money-exchange.svg"
                alt="" />
              <h3 class="title">Trading Exchanges</h3>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-10 col-md-6">
            <div class="single-feature">
              <img class="icon" src="assets/img/svg/wallet.svg" alt="" />
              <h3 class="title">Crypto Wallets</h3>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-10 col-md-6">
            <div class="single-feature">
              <img class="icon" src="assets/img/svg/analytics.svg" alt="" />
              <h3 class="title">Portfolio & Trackers</h3>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- iq feature end -->

  <!-- game begin -->
  <div class="games" id="games">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-7 col-sm-10">
          <div class="section-title style-2">
            <h2>thousands of free online games</h2>
            <p>
              Misco has thousands of free online games for all generation. Play
              action, racing, sports, and other fun games for free at Misco
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-4">
          <div class="game-menu">
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link active" href="#0">
                  <span class="text">All Genres</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#0">
                  <span class="text">Pragmatic</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#0">
                  <span class="text">Evolution</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#0">
                  <span class="text">Spribe</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-8">
          <div class="all-games anim-change">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game7.png" alt="" />
                    <img
                      class="icon-img"
                      src="../assets/images/games/icon-1.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game2.png" alt="" />
                    <img
                      class="icon-img"
                      src="assets/img/games/icon-2.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game3.png" alt="" />
                    <img
                      class="icon-img"
                      src="assets/img/games/icon-5.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game4.png" alt="" />
                    <img
                      class="icon-img"
                      src="assets/img/games/icon-3.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game5.png" alt="" />
                    <img
                      class="icon-img"
                      src="assets/img/games/icon-4.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-sm-6">
                <div class="single-game">
                  <div class="part-img">
                    <img src="../assets/images/game6.png" alt="" />
                    <img
                      class="icon-img"
                      src="assets/img/games/icon-6.png"
                      alt="" />
                  </div>
                  <div class="part-text">
                    <h4 class="game-title">IceBall 71</h4>
                    <router-link to="/casino/all" class="def-btn def-small"
                      >Play Now</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- game end -->

  <!-- cta begin -->
  <div class="cta">
    <div class="container">
      <div
        class="row justify-content-xl-between justify-content-lg-between justify-content-sm-center">
        <div class="col-xl-7 col-lg-7 col-md-8 col-sm-10">
          <h2>
            Betrider - Where everything are<br />
            possible with crypto gaming
          </h2>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-10">
          <router-link to="/casino/all" class="def-btn play-now-btn"
            >Play Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!-- cta end -->

  <!-- partner begin -->
  <div class="partner">
    <div class="container">
      <div
        class="row justify-content-xl-between justify-content-lg-between justify-content-sm-center justify-content-md-start">
        <div
          class="col-xl-5 col-lg-6 col-md-9 col-sm-10 d-xl-flex d-lg-flex d-block align-items-center">
          <div class="part-text">
            <h2 class="title">Partnered with Betrider</h2>
            <p>
              Join forces with a gaming platform trusted by players worldwide.
              Betrider partners enjoy exclusive benefits, cutting-edge features,
              and a thriving community of gamers. Whether you're a developer,
              streamer, or brand, our collaboration opens doors to new
              opportunities and shared success. Let's create something
              extraordinary together!
            </p>
            <!-- <a href="#0" class="def-btn">Join WIth Us</a> -->
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-10">
          <img
            src="../assets/images/providers/allproviders.png"
            alt="partners" />
          <!-- <div class="part-partner-logo">
            <div class="row no-gutters">
              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0"> </a>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0">
                    <img src="assets/img/partner/sponsor-2.png" alt="" />
                  </a>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0">
                    <img src="assets/img/partner/sponsor-3.png" alt="" />
                  </a>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0">
                    <img src="assets/img/partner/sponsor-5.png" alt="" />
                  </a>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0">
                    <img src="assets/img/partner/sponsor-4.png" alt="" />
                  </a>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-sm-6 col-md-4">
                <div class="single-logo">
                  <a href="#0">
                    <img src="assets/img/partner/sponsor-6.png" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- partner end -->

  <!-- payment gateways begin -->
  <div class="payment-gateway" id="payment">
    <div class="container">
      <div
        class="row justify-content-xl-between justify-content-lg-around justify-content-sm-center">
        <div
          class="col-xl-4 col-lg-4 col-sm-10 col-md-4 offset-xl-1 offset-lg-0 order-xl-0 order-lg-0 order-1">
          <div class="all-gateways">
            <img src="../assets/images/free_bonus.png" alt="" />
          </div>
        </div>
        <div
          class="col-xl-6 col-lg-7 col-sm-10 col-md-7 d-xl-flex d-lg-flex d-sm-block d-md-block d-block align-items-center order-xl-2 order-lg-2 order-0">
          <div class="part-text">
            <h2 class="title">Welcome Bonus</h2>
            <p class="md:tw-text-2xl tw-mb-2">
              Up to €1,750 + 150 FS + 1 Bonus Crab in 3 bonuses
            </p>
            <div
              class="def-btn tw-cursor-pointer"
              @click="openPopup('register')">
              Sign Up
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- payment gateways end -->

  <!-- testimonial begin -->
  <div class="testimonial" id="testimonial">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-7 col-sm-10">
          <div class="section-title style-2">
            <h2>Feedback to Betrider</h2>
            <p>
              Betrider has thousands of free online games for all generation.
              Play action, racing, sports, and other fun games for free
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <!-- First Testimonial Column -->
        <div class="col-xl-6 col-lg-6 col-sm-10">
          <div class="testimonial-slider owl-carousel owl-theme">
            <div class="single-testimonial">
              <div class="part-img">
                <img src="../assets/images/user.png" alt="" />
              </div>
              <div class="part-text">
                <p>
                  "Play casino and earn crypto in online. The ultimate online
                  casino platform. Play casino and earn crypto in online. The
                  ultimate online casino platform."
                </p>
                <span class="position"> Uahad Foiza </span>
                <span class="user-name"> Top Trader </span>
              </div>
            </div>
            <div class="single-testimonial">
              <div class="part-img">
                <img src="../assets/images/user.png" alt="" />
              </div>
              <div class="part-text">
                <p>
                  "Enjoy a wide range of casino games and earn rewards.
                  Experience the thrill of online gambling with our secure
                  platform."
                </p>
                <span class="position"> Fahad Foiz </span>
                <span class="user-name"> Top Poker </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Second Testimonial Column -->
        <div class="col-xl-6 col-lg-6 col-sm-10">
          <div class="testimonial-slider owl-carousel owl-theme">
            <div class="single-testimonial">
              <div class="part-img">
                <img src="../assets/images/user.png" alt="" />
              </div>
              <div class="part-text">
                <p>
                  "Experience the thrill of online gambling with our secure
                  platform. Experience the thrill of online gambling with our
                  secure platform."
                </p>
                <span class="position"> Stan Lazi </span>
                <span class="user-name"> Top Actor </span>
              </div>
            </div>
            <div class="single-testimonial">
              <div class="part-img">
                <img src="../assets/images/user.png" alt="" />
              </div>
              <div class="part-text">
                <p>
                  "Join the best online casino and win big! Experience the
                  thrill of online gambling with our secure platform."
                </p>
                <span class="position"> John Doe </span>
                <span class="user-name"> Top Trader </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- testimonial end -->

  <!-- Popular Game start -->
  <HomePopularGames :games="allGames" />
  <!-- Popular Game end -->
</template>

<script>
import Const from '@/const'
// import HomeProviders from "@/components/HomeProviders.vue";
// import HomeGameProviders from "@/components/HomeGameProviders.vue";
import { allGames } from '@/sampleData'
import { useAuthStore } from '../stores/authStore'
import { usePopupStore } from '../stores/popup'
// import { Carousel, Slide } from "vue3-carousel";
import { reactive, ref } from 'vue'

import Odometer from 'odometer'
import 'odometer/themes/odometer-theme-default.css'

export default {
  name: 'HomePage',
  components: {
    // HomeProviders,
    // Carousel,
    // Slide,
    // HomeGameProviders,
    // ReviewsComponent,
  },
  setup() {
    const config = reactive({
      itemsToShow: 1,
      autoplay: 6000,
      gap: 0,
      wrapAround: true,
      transition: 1000,
    })

    const carousel = ref(null)

    const prevSlide = () => {
      if (carousel.value) {
        carousel.value.prev()
      }
    }

    const nextSlide = () => {
      if (carousel.value) {
        carousel.value.next()
      }
    }

    return {
      config,
      carousel,
      prevSlide,
      nextSlide,
    }
  },
  data() {
    return {
      serverData: null, // Holds data fetched from the server
      allGames: allGames,
      welcomeBonusShowed: false,
      odometerValue: 2251259,
    }
  },
  computed: {
    // Access the isAuthenticated property from Pinia store
    isAuthenticated() {
      const authStore = useAuthStore()
      return authStore.isAuthenticated
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.actionScroll)
  },
  created() {
    window.addEventListener('scroll', this.actionScroll)
  },
  mounted() {
    //this.fetchHomeCasino(); // Fetch data when the component is mounted
    const odometerElement = document.querySelector('.odometer')
    if (odometerElement) {
      const odometerInstance = new Odometer({
        el: odometerElement,
        value: this.odometerValue,
      })
    }
  },
  methods: {
    openPopup(popup) {
      const popupStore = usePopupStore()
      popupStore.showPopup(popup)
    },
    actionScroll() {
      const scroll = window.scrollY
      if (scroll == 0 && this.welcomeBonusShowed == false) {
        // this.openPopup('welcome-bonus');
        // this.welcomeBonusShowed = true;
      }
    },
    async fetchHomeCasino() {
      const url = Const.URL

      const headers = {
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7,pl;q=0.6',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive',
        'Content-Type': 'application/json',
        Cookie:
          'remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d=eyJpdiI6ImpnUDhDZWNhZmlwUnhJczdCdjY3cEE9PSIsInZhbHVlIjoiTXNqeWFqVm1UeXJjSEFMMm5wS3liajlWL2Z6QWQvZklBQldlNytpbGJWUmorSDhZWU1ZL21qRURCVUR3UW8yVTN5V0lFczB4cS90MVpYcDF6N2VRZjh0N1c2aitLb1FGSW1Xd3FpYzFTSkVqTUtuSVkvL04xMDR4NW9MRUtFM1d2SXc3T0lRMldLSndRQjVMSTlkcGxoTEpQM1NvUEFmRDZkcFV2RXE4d2Q5a3N0VUpMM09zOTY2dHIxZzVxWnM4Q3M5clFmTU1YLzZUM3pOU2xzY0plS1VMODNTN3Q3Ym9RbC90MnVlNHRzRT0iLCJtYWMiOiI4MjA5OGQxOWUzZGZlZGJkMzY3MGE4MmI4OTA2YzU5ZmQyZDllMzc1ZTgxYzUxMzA5NzgyOTgzNzcyM2M0ZGIzIn0%3D; XSRF-TOKEN=eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0%3D; laravel_session=eyJpdiI6InN0UHFVTExkLzdwaU01cTNLVENldkE9PSIsInZhbHVlIjoiWDlsRk5nUnVWdTMzU1lKclllbG1KYXkxdkpHbEU5cXNPcGlBVks3ZGpBdmpRbFBiYVRhRWJRVC9RMjZ0N2xndTdlZndaZnRDdHNsOVBHWmVOUFgyallMWkNNQ0ZNNThHdldaTjliNUhhWWFxdUNWU0ZxVG84V3g1OWkrTWZ5c3IiLCJtYWMiOiIyYzk3ZWFiOWFiMzk4YjBiNmRkZWM4MGEzMmFhMzc5NTBjMjhjYTA3ZTE4YzAxMWE4YzRhYjRjNzVlMjY5YjJhIn0%3D',
        DNT: '1',
        Origin: 'https://azurecoinz.com',
        Pragma: 'no-cache',
        Referer: 'https://azurecoinz.com/home',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent':
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
        'X-XSRF-TOKEN':
          'eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0=',
        'sec-ch-ua':
          '"Google Chrome";v="131", "Chromium";v="131", "Not_A Brand";v="24"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '"macOS"',
        timeout: '10000',
      }

      const body = {}

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        this.serverData = data // Update the component's state with the fetched data
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
  },
}
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}
.home-wrapper .carousel__slide {
  justify-content: space-between;
}
.home-wrapper .custom-main-container {
  max-width: 1320px;
}

.scrollToTop {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 45px;
  height: 45px;
  background-color: red;
  border-radius: 5px;
  color: white;
  line-height: 45px;
  font-size: 20px;
  text-align: center;
  z-index: 99;
  cursor: pointer;
  transition: all 1s;
  transform: translateY(100%);
}

.counter-text h3 {
  font-size: 50px;
  color: $color_6;
  line-height: 24px;
  font-weight: 400;
  font-family: $font-family_3;
  text-transform: uppercase;
  cursor: auto;
  width: 50px;
  height: 68px;
  margin: 0 5px;
  margin-top: 4px;
  padding-top: 20px;
  background-image: linear-gradient(
    to bottom,
    #ffffff,
    #f1d5fa,
    #faa2dc,
    #ff66a2,
    #ff0052
  );
}

@media (max-width: 1400px) {
  .home-wrapper .custom-main-container {
    max-width: 1100px;
  }
}

@media (max-width: 1200px) {
  .home-wrapper .custom-main-container {
    max-width: calc(100% - 120px);
  }
  .banner-image-wrap {
    width: 50%;
  }
  .banner-image-wrap img {
    height: 100%;
    width: 100%;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 44px;
    line-height: normal;
  }
}

@media (max-width: 768px) {
  .home-wrapper .custom-main-container {
    max-width: 100%;
  }
  .banner-image-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
  }
  .home-wrapper .banner-image-wrap img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .home-wrapper .main-content {
    padding: 48px 40px;
  }
  .banner-section .overlay .banner-content {
    padding: 70px 0 0px;
  }
  .inner-content-element {
    margin: 0 auto;
  }
}

@media (max-width: 576px) {
  .home-wrapper .main-content {
    padding: 0 20px;
  }
  .home-wrapper .main-content .section-text .title {
    font-size: 40px;
    text-align: center;
  }
  .home-wrapper .main-content .section-text .xlr {
    text-align: center;
  }
  .banner-section.index .overlay .banner-content {
    padding: 87px 0 0px;
  }
  .inner-content-element {
    padding-bottom: 30px;
    padding-top: 100px;
  }
  .btn-element {
    text-align: center;
  }
  .counter-text h3 {
    font-size: 16px;
    color: $color_6;
    line-height: 24px;
    font-weight: 400;
    font-family: $font-family_3;
    text-transform: uppercase;
    cursor: auto;
    width: 30px;
    height: 40px;
    margin: 0 2px;
    margin-top: 4px;
    padding-top: 7px;
    background-image: linear-gradient(
      to bottom,
      #ffffff,
      #f1d5fa,
      #faa2dc,
      #ff66a2,
      #ff0052
    );
  }

  .partner {
    padding-bottom: 0;
  }

  .about .part-txt.right {
    margin-top: 50px;
    margin-left: 0;
    margin-right: 0;
  }
}

.banner-image-wrap img {
  overflow: clip;
  max-width: none;
  overflow-clip-margin: content-box;
  overflow: clip;
  max-height: 500px;
}

.banner-item .main-content {
  text-align: left;
}
</style>
